import React from 'react'
import styled from 'styled-components'

import NoResultsIcon from './NoResultsIcon'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 16px;
  background: var(--color-surface);
  border: 1px solid var(--card-border-color);
  border-radius: var(--t-borders-radius-rounded-2xl);
  box-shadow: var(--shadow-1);
`

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`

const Title = styled.div`
  font-size: var(--t-typography-font-size-base);
  color: var(--color-text);
  font-weight: var(--t-typography-font-weight-semi-bold);
  line-height: var(--t-typography-line-height-base);
  text-align: center;
`

const Description = styled.div`
  font-size: var(--t-typography-font-size-xs);
  color: var(--sub-text-color);
  font-weight: var(--t-typography-font-weight-medium);
  line-height: var(--t-typography-line-height-xs);
  text-align: center;
`

const NoResultsState = () => (
  <Container data-testid="Psima_Dashboard_CardSection_NoResultsState_div">
    <NoResultsIcon />
    <TextGroup>
      <Title>No simulations match this filter</Title>
      <Description>Try clearing the filter.</Description>
    </TextGroup>
  </Container>
)

export default NoResultsState
